/* eslint-disable no-unused-vars */
import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2, Home, Eye, EyeOff, RefreshCw, LogOut, Edit2, Save, X, Upload, Download, Volume2, Sparkles, Hash, Trophy, FileDown, FileUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { API, BACKEND_URL, resolveUrl, useAdmin } from "./adminShared";

export const VotesTab = () => {
  const {
    countries, setCountries, votes, setVotes, events, setEvents,
    activeEvent, setActiveEvent, showCreateEvent, setShowCreateEvent, newEventName, setNewEventName,
    copyFromEventId, setCopyFromEventId, creatingEvent, setCreatingEvent, showRenameEvent, setShowRenameEvent,
    renameEventName, setRenameEventName, importFile, setImportFile, showImportConfirm, setShowImportConfirm,
    importing, setImporting, newCountry, setNewCountry, editingCountry, setEditingCountry,
    backgroundVideo, setBackgroundVideo, fontTitle, setFontTitle, fontSubtitle, setFontSubtitle,
    fontCountry, setFontCountry, fontPoints, setFontPoints, fontVoting, setFontVoting,
    customFontTitleUrl, setCustomFontTitleUrl, customFontTitleName, setCustomFontTitleName, customFontSubtitleUrl, setCustomFontSubtitleUrl,
    customFontSubtitleName, setCustomFontSubtitleName, customFontCountryUrl, setCustomFontCountryUrl, customFontCountryName, setCustomFontCountryName,
    customFontPointsUrl, setCustomFontPointsUrl, customFontPointsName, setCustomFontPointsName, customFontVotingUrl, setCustomFontVotingUrl,
    customFontVotingName, setCustomFontVotingName, fontSizeTitle, setFontSizeTitle, fontSizeSubtitle, setFontSizeSubtitle,
    fontSizeCountry, setFontSizeCountry, fontSizePoints, setFontSizePoints, fontSizeVoting, setFontSizeVoting,
    primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, tertiaryColor, setTertiaryColor,
    rowBgEven, setRowBgEven, rowBgOdd, setRowBgOdd, logoUrl, setLogoUrl,
    logoPosition, setLogoPosition, logoSize, setLogoSize, logoZIndex, setLogoZIndex,
    logoOpacity, setLogoOpacity, extraImage1Url, setExtraImage1Url, extraImage1Position, setExtraImage1Position,
    extraImage1Size, setExtraImage1Size, extraImage1ZIndex, setExtraImage1ZIndex, extraImage1Opacity, setExtraImage1Opacity,
    extraImage2Url, setExtraImage2Url, extraImage2Position, setExtraImage2Position, extraImage2Size, setExtraImage2Size,
    extraImage2ZIndex, setExtraImage2ZIndex, extraImage2Opacity, setExtraImage2Opacity, extraImage3Url, setExtraImage3Url,
    extraImage3Position, setExtraImage3Position, extraImage3Size, setExtraImage3Size, extraImage3ZIndex, setExtraImage3ZIndex,
    extraImage3Opacity, setExtraImage3Opacity, defaultArtistPhoto, setDefaultArtistPhoto, artistPhotoSizeMode, setArtistPhotoSizeMode,
    artistPhotoSizePx, setArtistPhotoSizePx, textTitle, setTextTitle, textSubtitle, setTextSubtitle,
    textVotingNow, setTextVotingNow, textWaiting, setTextWaiting, sound12PointsUrl, setSound12PointsUrl,
    confettiEnabled, setConfettiEnabled, confettiColors, setConfettiColors, top1Color, setTop1Color,
    top2Color, setTop2Color, top3Color, setTop3Color, lastPlaceColor, setLastPlaceColor,
    top1Translucent, setTop1Translucent, top2Translucent, setTop2Translucent, top3Translucent, setTop3Translucent,
    lastPlaceTranslucent, setLastPlaceTranslucent, votingColumnCenter, setVotingColumnCenter, leftColSpan, setLeftColSpan,
    rightColSpan, setRightColSpan, votingColSpan, setVotingColSpan, columnGap, setColumnGap,
    subtitleCounterEnabled, setSubtitleCounterEnabled, subtitlePhaseOrder, setSubtitlePhaseOrder, subtitleJuryLabel, setSubtitleJuryLabel,
    subtitleTelevoteLabel, setSubtitleTelevoteLabel, mystery12Text, setMystery12Text, voteDisplayColumns, setVoteDisplayColumns,
    showVoterBorder, setShowVoterBorder, showJuryBadge, setShowJuryBadge, fontVotingSecondary, setFontVotingSecondary,
    customFontVotingSecondaryUrl, setCustomFontVotingSecondaryUrl, customFontVotingSecondaryName, setCustomFontVotingSecondaryName, overlay12Enabled, setOverlay12Enabled,
    overlay12DurationMode, setOverlay12DurationMode, overlay12DurationSeconds, setOverlay12DurationSeconds, overlay12BgStyle, setOverlay12BgStyle,
    overlay12BgColor, setOverlay12BgColor, overlay12BgOpacity, setOverlay12BgOpacity, overlay12TextReceives, setOverlay12TextReceives,
    overlay12UseAdminColors, setOverlay12UseAdminColors, overlay12Visible, setOverlay12Visible, previewGiverId, setPreviewGiverId,
    previewRecipientId, setPreviewRecipientId, winnerOverlayEnabled, setWinnerOverlayEnabled, winnerOverlayDurationMode, setWinnerOverlayDurationMode,
    winnerOverlayDurationSeconds, setWinnerOverlayDurationSeconds, winnerOverlayBgStyle, setWinnerOverlayBgStyle, winnerOverlayBgColor, setWinnerOverlayBgColor,
    winnerOverlayBgOpacity, setWinnerOverlayBgOpacity, winnerOverlayTitleText, setWinnerOverlayTitleText, winnerOverlaySubtitleText, setWinnerOverlaySubtitleText,
    winnerOverlayUseAdminColors, setWinnerOverlayUseAdminColors, winnerOverlayShowConfetti, setWinnerOverlayShowConfetti, winnerOverlayShowPoints, setWinnerOverlayShowPoints,
    winnerOverlayVisible, setWinnerOverlayVisible, overlay12StyleCustom, setOverlay12StyleCustom, overlay12FontTitle, setOverlay12FontTitle,
    overlay12FontCountry, setOverlay12FontCountry, overlay12FontSecondary, setOverlay12FontSecondary, overlay12SizeScale, setOverlay12SizeScale,
    winnerOverlayStyleCustom, setWinnerOverlayStyleCustom, winnerOverlayFontTitle, setWinnerOverlayFontTitle, winnerOverlayFontCountry, setWinnerOverlayFontCountry,
    winnerOverlayFontSecondary, setWinnerOverlayFontSecondary, winnerOverlaySizeScale, setWinnerOverlaySizeScale, loading, setLoading,
    exportingPdf, setExportingPdf, winnerPreviewId, setWinnerPreviewId, adminInitRef, adminPollRef,
    navigate, fetchCurrentVoterStatus, handleHideOverlay12, handlePreviewOverlay12, handleShowWinner, handleHideWinner,
    getFontFormat, fetchBackground, handleSetBackground, handleExportPdf, handleFileUpload, fetchCountries,
    fetchVotes, downloadFromApi, handleExportVotesPdf, handleExportVotesExcel, fetchEvents, reloadEventData,
    handleSelectEvent, handleCreateEvent, handleRenameEvent, handleExportEvent, handleImportEvent, handleAddCountry,
    handleDeleteCountry, handleSetCurrentVoter, handleResetVotes, handleLogout, handleApplyVotes, handleReveal12Points,
    handleEditCountry, handleUpdateCountry, handleToggleBadge, handleToggleTranslucent, votingCountries, juryMembers,
    votedCountries,
  } = useAdmin();
  return (
          <TabsContent value="votes" className="space-y-4 mt-6">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <h2 className="font-unbounded text-xl text-white">Votos Recibidos ({votes.length})</h2>
              <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                <Button
                  data-testid="btn-export-votes-pdf"
                  onClick={handleExportVotesPdf}
                  disabled={votes.length === 0}
                  variant="outline"
                  className="w-full sm:w-auto bg-zinc-900 border-pink-700 text-pink-300 hover:bg-pink-900/30"
                >
                  <Download className="w-4 h-4 mr-2" />
                  Exportar PDF
                </Button>
                <Button
                  data-testid="btn-export-votes-excel"
                  onClick={handleExportVotesExcel}
                  disabled={votes.length === 0}
                  variant="outline"
                  className="w-full sm:w-auto bg-zinc-900 border-emerald-700 text-emerald-300 hover:bg-emerald-900/30"
                >
                  <Download className="w-4 h-4 mr-2" />
                  Exportar Excel
                </Button>
                <Button
                  data-testid="btn-reset-votes"
                  onClick={handleResetVotes}
                  variant="outline"
                  className="w-full sm:w-auto bg-red-900/20 border-red-800 text-red-400 hover:bg-red-900/40"
                >
                  <RefreshCw className="w-4 h-4 mr-2" />
                  Resetear Votos
                </Button>
              </div>
            </div>
            {votes.length === 0 ? (
              <Card className="bg-zinc-900/80 border-zinc-800 p-8 text-center">
                <p className="text-zinc-500">No hay votos aún</p>
              </Card>
            ) : (() => {
              const juryIds = new Set(countries.filter(c => c.is_jury).map(c => c.id));
              const juryVotes = votes.filter(v => juryIds.has(v.from_country_id));
              const countryVotes = votes.filter(v => !juryIds.has(v.from_country_id));

              const renderVoteCard = (vote) => (
                <Card key={vote.id} className="bg-zinc-900/80 border-zinc-800 p-6">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="font-unbounded text-white text-lg">{vote.from_country_name}</h3>
                    <span className="text-zinc-500 text-sm">{new Date(vote.submitted_at).toLocaleString('es-ES')}</span>
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                    {Object.entries(vote.votes).sort((a, b) => a[1] - b[1]).map(([countryId, points]) => {
                      const country = countries.find(c => c.id === countryId);
                      return (
                        <div key={countryId} className="bg-zinc-800/50 rounded-lg p-3 text-center border border-zinc-700">
                          <p className="text-zinc-400 text-xs mb-1">{country?.name || 'Desconocido'}</p>
                          <p className="font-mono font-bold text-pink-500 text-xl">{points}</p>
                        </div>
                      );
                    })}
                  </div>
                </Card>
              );

              return (
                <div className="space-y-8">
                  {juryVotes.length > 0 && (
                    <div className="space-y-3" data-testid="votes-jury-block">
                      <div className="flex items-center gap-3 pb-2 border-b border-zinc-800">
                        <div className="w-1 h-6 bg-yellow-500 rounded-full" />
                        <h3 className="font-unbounded text-yellow-400 text-lg uppercase tracking-wider">Jurado</h3>
                        <span className="text-zinc-500 text-sm">({juryVotes.length})</span>
                      </div>
                      <div className="space-y-4">
                        {juryVotes.map(renderVoteCard)}
                      </div>
                    </div>
                  )}
                  {countryVotes.length > 0 && (
                    <div className="space-y-3" data-testid="votes-countries-block">
                      <div className="flex items-center gap-3 pb-2 border-b border-zinc-800">
                        <div className="w-1 h-6 bg-pink-500 rounded-full" />
                        <h3 className="font-unbounded text-pink-400 text-lg uppercase tracking-wider">Países</h3>
                        <span className="text-zinc-500 text-sm">({countryVotes.length})</span>
                      </div>
                      <div className="space-y-4">
                        {countryVotes.map(renderVoteCard)}
                      </div>
                    </div>
                  )}
                </div>
              );
            })()}
          </TabsContent>
  );
};
